import { USERS_ENDPOINT } from "Constants";
import { baseApi } from "Services";
import { ChangePasswordRequest, UpdateUserRequest } from "../types";

export const userSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateUser: builder.mutation<void, UpdateUserRequest>({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/users/${queryArg.userId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
      invalidatesTags: ["Users"],
    }),
    changePassword: builder.mutation<void, ChangePasswordRequest>({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/users/change-my-password`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateUserMutation, useChangePasswordMutation } =
  userSettingsApi;
